import React from 'react';
import './GiftCard.style.css';
import { STORE_URL } from 'utils';

const GiftCard = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    title = null,
    url = null,
    onClick,
    active = false,
    style = {},
  } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div
      className={`gift-card-wrap ${active ? 'gift-card-item-active' : ''}`}
      style={{ ...style }}
    >
      {!url ? (
        <div className="empty-gift-card">JM COFFEE</div>
      ) : (
        <div
          className={`gift-card-item`}
          style={{
            background: `url(${STORE_URL}/${url}) no-repeat center center/cover`,
          }}
          onClick={onClick}
        />
      )}
    </div>
  );
};

export default GiftCard;
